import { Survey_Metrics_Period } from '@occc/graphql';
import { RangeTypeWithCustom } from '@occc/ui-design-system';

export const presetToPeriod: Partial<Record<RangeTypeWithCustom, Survey_Metrics_Period>> = {
  last_7_days: Survey_Metrics_Period.Last_7Days,
  last_30_days: Survey_Metrics_Period.Last_30Days,
  last_365_days: Survey_Metrics_Period.AllTime,
  custom: Survey_Metrics_Period.Custom,
};
